import { createMachine } from 'xstate';
export const appMachine = createMachine({
    /** @xstate-layout N4IgpgJg5mDOIC5QEEAKqD6BlAKsnAogHQAyA8sgCICSAcgOIDEA9gHZYAuAhgE4cDaABgC6iUAAdmsAJYdpbMSAAeiAIwA2AMxFNATgAce-QCYArKd2n9gzQBoQATzW7jRAOwAWA-tUHNH40EPDwBfEPs0TFx8YjpqHBZWAh4eZh4hUSQQSRk5BSyVBABaN0EiY3VBN1ULTX1PXTc3eycEVVVjXXc3dV8PT3VA4zcwiPRsPEIiOJxp2niMSIwAYTJaHAAlMhISAg3E+i4AWzANsC4IBwzFHNl5VkVC9WCiLzNfVUFjTTdDFsR-KpXuZPKp6p1gqFwiAltEpjM5gsSFhsHsAGp7RLLNisMAAYw4kGuWVueQeBUQz305WMnQ0xg8P00glM-wQxn0ph0lQ8lW+6gFw00oxh4zhxGQyxw1AxiTIADcwOkRDcpHd8qBCh4gkRdB4appmb89OpWY5EJY3ERVB59PpnobjL4nSLYZMJVKZQQ5YqeAAbLjiYkSNVkx4A3TaXQuXxVQT237BNkmdS6tx1L6mMwWIKusXuoiS6WytjJVLKzIh3L3cPswxEQRVfT9dS-YZ69Rsz6aVMeUyCT41fq8jR5qIF6iUXZY5hHcRcaSsKDB7KhmsU4qqTRAocdYaNxkOtlaMrmRqNMFaZ5jiYxIgACUn3rYAFVWAqlQGgyqSWuNcoAXrXRVDcXRKiCeo9C3NkmiBL59XaTpdHjNxTBvcUiD2LZ9h4fEcXxAQfyrdVyU1RBSitXlLGbUx-EjfRdC7DouiaXo9QGIY0JFVhmAgOBFDdGJVWrf9CiKECul3WlSiCHtGTZIpoyIZsmkaQR1HtTRTGvaFBKmcgqDoehhJI2salcfVrECUxqnjW1mnNTdXH8VTI37NxvnTYVdPzO8ZhMsMNwqVwTFkzQKjA6MgjZb5qWjaNPLeGyvnQid5lmGZFnGVZ1i2HY9gC9cyIQbcylCxlwvUSLkI8NlKteeKwX8eNtKaVK-PSxEcAwZFUQ2DENkK0TEBMLoLA0-VW16HpascwEG1KBiqvTAVfnaqYiy9IbSIAhBtOtIIAhsAdegHOxHKq7RtWsRlTGCPUKnW2IpwIbba0UroGUbQQXBWu79Dq75ul6O1I1AllVCeh8nzejc7qtUwbVo4CGTtKoYIsIgBT7ZL9VA3kobIAbYeK8wuRHZLgKsdNZtaZDXG+MFQOA00XF0KGsLIQbfxEnatS0ZSzzu7H+wqc7WnaX4Dv8aa9TtDywjCIA */
    id: 'APP_STATE',
    initial: "LOADING",
    predictableActionArguments: true,
    states: {
        LOADING: {
            on: {
                onStart: "INIT"
            }
        },

        INIT: {
            on: {
                onError: "#APP_STATE.ERROR"
            },
            states: {
                INIT_APP_CONTROLLER: {
                    entry: ['activateAppController'],
                    on: {
                        // onGameReady: "INIT_LS_SERVER",
                        onGameReady: "#APP_STATE.ACTIVE"
                        
                    }
                },

                INIT_LS_SERVER: {
                    entry: ['initLSServer'],
                    on: {
                        onConnected: "#APP_STATE.ACTIVE"
                    }
                }
            },

            initial: "INIT_APP_CONTROLLER"
        },

        ACTIVE: {
            entry: ["subscribeChangeOnActive"],
            exit: ["unsubscribeChangeOnActive"],
            on: {
                onOver: {
                    target: "OVER",
                },
                onOverlap: { target: "HIDE" },

                onError: "ERROR"
            }
        },

        IDLE: {
            on: {
                onCampaign: {
                    target: "ACTIVE",
                }
            }
        },

        HIDE: {
            entry: ["subscribeChangeOnHide"],
            exit: ["unsubscribeChangeOnHide"],

            on: {
                onUnOverlap: {
                    target: "ACTIVE",
                }
            }
        },
        OVER: {
            entry: ["onAppOver"],

        },


        ERROR: {
            entry: ["unpauseGame"],
            on: {
                reconnect: "INIT.INIT_LS_SERVER"
            }
        }
    }
});